module.exports = __webpack_public_path__ + "static/Unitel-b4da84bda01a2df4075aeb1ef4575152.webp";